import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IContentSection } from '../../../../shared/interfaces/card-info.interface';
import { RevealDirective } from '../../../../shared/directives/reveal.directive';

@Component({
  selector: 'app-tag-services',
  imports: [RouterLink, RevealDirective],
  templateUrl: './tag-services.html',
  styleUrl: './tag-services.scss'
})
export class TagServices {
  /** Supplies heading + lead copy + bullets (kept in landing-sections.ts so copy never drifts). */
  @Input({ required: true }) section!: IContentSection;

  /** Optional destination for the section heading (links to the matching service page). */
  @Input() link?: string;

  /** Tag marker style: 'dot' (gradient circle) or 'check' (circled gradient checkmark). */
  @Input() marker: 'dot' | 'check' = 'dot';

  /** 'split' = heading left / copy right; 'center' = heading + copy centered. */
  @Input() layout: 'split' | 'center' = 'split';

  /** Lead paragraphs minus the eyebrow line (the short lead that ends with a colon). */
  get bodyLead(): string[] {
    return (this.section.lead ?? []).filter((p) => !/:\s*$/.test(p.trim()));
  }

  /** Eyebrow above the tags — the data's colon-terminated lead line, or a sensible default. */
  get eyebrow(): string {
    return (this.section.lead ?? []).find((p) => /:\s*$/.test(p.trim())) ?? 'services include:';
  }
}
